import React from "react";
import { Row, Card, Button } from "react-bootstrap";
// helper
import { infoCardComponent } from "../../helper/card";
// icons
import { FiDownload } from "react-icons/fi";
import { IoMdOpen } from "react-icons/io";

const cardStyle = { width: "390px" };

const InfoTabPatient = () => {
  return (
    <Row className="d-flex flex-wrap">
      {infoCardComponent({
        title: "Was ist SysDok?",
        content: (
          <>
            <Card.Text>
              Bei SysDok handelt es sich um eine Online-Plattform, auf der
              Patient:innen (und gegebenenfalls Angehörige) im Verlauf und nach
              Beendigung ihrer Psychotherapie regelmäßig an anonymen Befragungen
              teilnehmen. Die zugehörigen Therapeut:innen erhalten automatisch
              eine Auswertung der Befragungen zur Nutzung für die weitere
              Therapie.
            </Card.Text>

            <a
              href="https://sysdok.de/de/fuer-patientinnen/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="primary">
                <IoMdOpen /> weitere Details zum Projekt
              </Button>
            </a>
          </>
        ),
        style: cardStyle,
      })}
      {infoCardComponent({
        title: "Wie nutzen Sie Ihren persönlichen SysDok-Account?",
        content: (
          <>
            <Card.Text>
              Hier finden Sie eine detaillierte Anleitung, wie Sie Ihren
              persönlichen SysDok-Account nutzen können (z.B. Antworten auf
              Fragen zu Login, Zeitfenstern der Befragungen, Ihren
              Erinnerungsmails, Kontaktmöglichkeiten bei Rückfragen).
            </Card.Text>
            <a
              tabIndex={-1}
              href="https://sysdok.de/%5Efiler/canonical/1698387252/146/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="primary">
                <FiDownload /> Anleitung
              </Button>
            </a>
          </>
        ),
        style: cardStyle,
      })}
      {infoCardComponent({
        title: "Studieninformationen für Patient*innen",
        content: (
          <>
            <Card.Text>
              Sie können an den SysDok-Befragungen nur teilnehmen, wenn Sie in
              die Teilnahme an der begleitenden Studie zu SysDok zustimmen. Hier
              können Sie die Informationen zur Studie und zum Datenschutz
              herunterladen.
            </Card.Text>

            <a
              tabIndex={-1}
              href="https://sysdok.de/%5Efiler/canonical/1698387252/148/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="primary">
                <FiDownload /> Studieninformationen herunterladen
              </Button>
            </a>
          </>
        ),
        style: cardStyle,
      })}
    </Row>
  );
};

export default InfoTabPatient;
